import styled from '@emotion/styled';
import { Button, Text } from '@lbcamden/lib-react';

export const ResidentHistoryRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
  margin-top: ${({ theme }) => theme.spacing(12)};
`;
export const Timeline = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(4)};

  > ${Button} {
    align-self: center;
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const TimelineToolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing([2, 4])};
  align-items: center;
  justify-content: space-between;
`;

export const GroupHeading = styled.div`
  display: flex;
  align-items: center;

  hr {
    flex: 1;
    border-top: ${({ theme }) => theme.borderLight};
  }

  ${Text} {
    margin: ${({ theme }) => theme.spacing([0, 4])};
  }
`;

export const NoResults = styled(Text)`
  align-self: center;
  padding: ${({ theme }) => theme.spacing(6)};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textSecondary};
`;
